'use strict';
/* eslint-disable react/jsx-handler-names */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _reactDom = require('react-dom');

var _immutable = require('immutable');

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _Conversation = require('conversations-schema/records/Conversation');

var _Conversation2 = _interopRequireDefault(_Conversation);

var _ChatArea = require('conversations-core/components/widget/ChatArea');

var _ChatArea2 = _interopRequireDefault(_ChatArea);

var _WidgetHeader = require('conversations-core/components/widget/WidgetHeader');

var _WidgetHeader2 = _interopRequireDefault(_WidgetHeader);

var _MeetingsLinkButton = require('conversations-core/components/widget/MeetingsLinkButton');

var _MeetingsLinkButton2 = _interopRequireDefault(_MeetingsLinkButton);

var _strings = require('conversations-core/constants/strings');

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _color = require('conversations-core/utils/color');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OFFSET_HEIGHT = 64;
var MOBILE_OFFSET_HEIGHT = 104;

exports.default = _react2.default.createClass({
  displayName: 'Widget',

  propTypes: {
    widgetData: _react.PropTypes.instanceOf(_WidgetData2.default).isRequired,
    currentChannel: _react.PropTypes.string,
    conversations: _react.PropTypes.instanceOf(_immutable.Map),
    currentConversation: _react.PropTypes.instanceOf(_Conversation2.default),
    publishMessage: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func,
    sendVisitorEmailAddress: _react.PropTypes.func,
    chatHistoryFetchStatus: _react.PropTypes.oneOf(Object.keys(_RequestStatusTypes2.default)),
    clickedMeetingsLink: _react.PropTypes.func,
    clickedForUserDescription: _react.PropTypes.func,
    fetchChatHistory: _react.PropTypes.func,
    mobile: _react.PropTypes.bool,
    preview: _react.PropTypes.bool,
    onClose: _react.PropTypes.func.isRequired,
    chatInputChanged: _react.PropTypes.func,
    showTypingIndicator: _react.PropTypes.bool,
    displayResponderOnline: _react.PropTypes.bool.isRequired,
    isOnlineMode: _react.PropTypes.bool.isRequired,
    showEmailCapture: _react.PropTypes.bool.isRequired,
    emailCaptureMessage: _react.PropTypes.string,
    emailCaptureMessageIndex: _react.PropTypes.number,
    visiblyOffline: _react.PropTypes.bool.isRequired,
    liveChatLink: _react.PropTypes.string,
    onLinkClick: _react.PropTypes.func.isRequired,
    hasUnansweredQuickReplyMessage: _react.PropTypes.bool,
    isAgentReady: _react.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      chatHeight: null
    };
  },
  componentDidMount: function componentDidMount() {
    var userDescription = this.getUserDescriptionNode().getBoundingClientRect();
    this.userDescriptionHeight = userDescription.height;
  },
  setHeaderRef: function setHeaderRef(element) {
    this.headerRef = element ? (0, _reactDom.findDOMNode)(element) : null;
  },
  getUserDescriptionNode: function getUserDescriptionNode() {
    return this.headerRef.querySelector('.' + _strings.USER_DESCRIPTION_NODE_CLASSNAME);
  },
  getNewChatHeight: function getNewChatHeight() {
    return this.userDescriptionHeight;
  },
  toggleChatHeight: function toggleChatHeight() {
    var _props = this.props,
        mobile = _props.mobile,
        _props$widgetData = _props.widgetData,
        aboutMe = _props$widgetData.aboutMe,
        jobTitle = _props$widgetData.jobTitle,
        clickedForUserDescription = _props.clickedForUserDescription;

    var offsetHeight = mobile ? MOBILE_OFFSET_HEIGHT : OFFSET_HEIGHT;

    if (!aboutMe && !jobTitle) {
      return;
    }

    if (this.state.chatHeight !== null) {
      this.setState({ chatHeight: null });
      return;
    }

    clickedForUserDescription();
    this.setState({
      chatHeight: 'calc(100% - ' + (offsetHeight + this.userDescriptionHeight) + 'px)'
    });
  },
  getChatStyle: function getChatStyle() {
    return {
      height: this.state.chatHeight
    };
  },
  getWidgetClassName: function getWidgetClassName() {
    return (0, _reactUtils.classNames)('chat-widget', { mobile: this.props.mobile });
  },
  hasChatHistoryResolved: function hasChatHistoryResolved() {
    var _props2 = this.props,
        isOnlineMode = _props2.isOnlineMode,
        chatHistoryFetchStatus = _props2.chatHistoryFetchStatus;


    return !isOnlineMode || chatHistoryFetchStatus === _RequestStatusTypes2.default.FAILED || chatHistoryFetchStatus === _RequestStatusTypes2.default.SUCCEEDED;
  },
  renderMeetingsLinkButton: function renderMeetingsLinkButton() {
    var _props3 = this.props,
        _props3$widgetData = _props3.widgetData,
        meetingsLinkUrl = _props3$widgetData.meetingsLinkUrl,
        meetingsLinkText = _props3$widgetData.meetingsLinkText,
        coloring = _props3$widgetData.coloring,
        clickedMeetingsLink = _props3.clickedMeetingsLink;


    if (!meetingsLinkUrl) {
      return null;
    }

    return _react2.default.createElement(_MeetingsLinkButton2.default, {
      coloring: coloring,
      meetingsLinkUrl: meetingsLinkUrl,
      meetingsLinkText: meetingsLinkText,
      onClick: clickedMeetingsLink
    });
  },
  renderChatArea: function renderChatArea() {
    var _props4 = this.props,
        widgetData = _props4.widgetData,
        currentChannel = _props4.currentChannel,
        sendVisitorEmailAddress = _props4.sendVisitorEmailAddress,
        fetchChatHistory = _props4.fetchChatHistory,
        preview = _props4.preview,
        showTypingIndicator = _props4.showTypingIndicator,
        chatHistoryFetchStatus = _props4.chatHistoryFetchStatus,
        publishMessage = _props4.publishMessage,
        chatInputChanged = _props4.chatInputChanged,
        isOnlineMode = _props4.isOnlineMode,
        republishMessage = _props4.republishMessage,
        showEmailCapture = _props4.showEmailCapture,
        emailCaptureMessage = _props4.emailCaptureMessage,
        emailCaptureMessageIndex = _props4.emailCaptureMessageIndex,
        currentConversation = _props4.currentConversation,
        mobile = _props4.mobile,
        visiblyOffline = _props4.visiblyOffline,
        liveChatLink = _props4.liveChatLink,
        onLinkClick = _props4.onLinkClick,
        hasUnansweredQuickReplyMessage = _props4.hasUnansweredQuickReplyMessage,
        isAgentReady = _props4.isAgentReady;


    return _react2.default.createElement(_ChatArea2.default, {
      widgetData: widgetData,
      currentChannel: currentChannel,
      currentConversation: currentConversation,
      sendVisitorEmailAddress: sendVisitorEmailAddress,
      chatHistoryFetchStatus: chatHistoryFetchStatus,
      fetchChatHistory: fetchChatHistory,
      preview: preview,
      showTypingIndicator: showTypingIndicator,
      publishMessage: publishMessage,
      republishMessage: republishMessage,
      chatInputChanged: chatInputChanged,
      isOnlineMode: isOnlineMode,
      showEmailCapture: showEmailCapture,
      emailCaptureMessageIndex: emailCaptureMessageIndex,
      emailCaptureMessage: emailCaptureMessage,
      mobile: mobile,
      visiblyOffline: visiblyOffline,
      liveChatLink: liveChatLink,
      onLinkClick: onLinkClick,
      hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage,
      isAgentReady: isAgentReady
    });
  },
  render: function render() {
    var _props5 = this.props,
        _props5$widgetData = _props5.widgetData,
        _props5$widgetData$re = _props5$widgetData.responder,
        avatar = _props5$widgetData$re.avatar,
        firstName = _props5$widgetData$re.firstName,
        aboutMe = _props5$widgetData.aboutMe,
        jobTitle = _props5$widgetData.jobTitle,
        coloring = _props5$widgetData.coloring,
        mobile = _props5.mobile,
        onClose = _props5.onClose,
        displayResponderOnline = _props5.displayResponderOnline;


    return _react2.default.createElement(
      'div',
      { className: this.getWidgetClassName() },
      _react2.default.createElement(
        'div',
        { className: 'background-panel' },
        _react2.default.createElement(
          'div',
          (0, _color.getBrandClassNameAndStyle)(coloring.accentColor, 'background-panel-content'),
          _react2.default.createElement(_WidgetHeader2.default, {
            ref: this.setHeaderRef,
            avatar: avatar,
            name: firstName,
            jobTitle: jobTitle,
            aboutMe: aboutMe,
            displayResponderOnline: displayResponderOnline,
            mobile: mobile,
            onClick: this.toggleChatHeight,
            onClose: onClose,
            coloring: coloring
          })
        )
      ),
      _react2.default.createElement(
        'div',
        {
          className: 'messages-interaction-container',
          style: this.getChatStyle()
        },
        this.renderMeetingsLinkButton(),
        this.renderChatArea()
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/widget/Widget.js
// module id = 281
// module chunks = 0 1